import React, { useState } from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    FormControl,
    FormHelperText,
    InputLabel,
    OutlinedInput,
    Typography,
    CircularProgress,
    InputAdornment,
    IconButton,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import Auth from "apis/auth/auth.api";

const authApi = new Auth();

const ResetPassword = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const { phone, resetToken } = location.state || {};

    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const [loading, setLoading] = useState(false);

    const handleResetPassword = async () => {
        if (!newPassword.trim()) {
            return toast.error("Please enter new password");
        }

        if (newPassword.length < 6) {
            return toast.error("Password must be at least 6 characters");
        }

        if (newPassword !== confirmPassword) {
            return toast.error("Passwords do not match");
        }

        try {
            setLoading(true);

            const response = await authApi.resetPassword({
                resetToken,
                password: newPassword,
                role: "ADMIN",
            });

            if (response?.status === 200) {
                toast.success("Password reset successfully");

                navigate("/auth/login");
            } else {
                toast.error(response?.message || "Failed to reset password");
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to reset password");
        } finally {
            setLoading(false);
        }

    };

    return (<Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        bgcolor="#f5f5f5"
        p={2}
    >
        <Card sx={{ width: 450, maxWidth: "100%" }}> <CardContent> <Typography
            variant="h4"
            textAlign="center"
            mb={1}
            fontWeight={600}
        >
            Reset Password </Typography>

            <Typography
                variant="body2"
                textAlign="center"
                color="text.secondary"
                mb={4}
            >
                Create your new password
            </Typography>

            <FormControl fullWidth margin="normal">
                <InputLabel>New Password</InputLabel>

                <OutlinedInput
                    type={showPassword ? "text" : "password"}
                    label="New Password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                onClick={() =>
                                    setShowPassword((prev) => !prev)
                                }
                                edge="end"
                            >
                                {showPassword ? (
                                    <VisibilityOff />
                                ) : (
                                    <Visibility />
                                )}
                            </IconButton>
                        </InputAdornment>
                    }
                />

                <FormHelperText>
                    Minimum 6 characters
                </FormHelperText>
            </FormControl>

            <FormControl fullWidth margin="normal">
                <InputLabel>Confirm Password</InputLabel>

                <OutlinedInput
                    type={showConfirmPassword ? "text" : "password"}
                    label="Confirm Password"
                    value={confirmPassword}
                    onChange={(e) =>
                        setConfirmPassword(e.target.value)
                    }
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                onClick={() =>
                                    setShowConfirmPassword((prev) => !prev)
                                }
                                edge="end"
                            >
                                {showConfirmPassword ? (
                                    <VisibilityOff />
                                ) : (
                                    <Visibility />
                                )}
                            </IconButton>
                        </InputAdornment>
                    }
                />
            </FormControl>

            <Button
                fullWidth
                variant="contained"
                color="secondary"
                sx={{ mt: 3 }}
                onClick={handleResetPassword}
                disabled={loading}
            >
                {loading ? (
                    <CircularProgress size={22} />
                ) : (
                    "Reset Password"
                )}
            </Button>

            <Button
                fullWidth
                variant="outlined"
                sx={{ mt: 2 }}
                onClick={() => navigate("/auth/login")}
            >
                Back to Login
            </Button>
        </CardContent>
        </Card>
    </Box>

    );
};

export default ResetPassword;
